import { EquatableKeyStackItem } from './EquatableKeyStackItem';
export class AccountStackItem extends EquatableKeyStackItem {
    asAccount() {
        return this.value;
    }
}

//# sourceMappingURL=AccountStackItem.js.map
